import { API_BASE_URL, HAS_API_URL } from '../config/api';

/**
 * In development, use same-origin `/api/...` so setupProxy forwards to REACT_APP_API_URL
 * (avoids browser CORS when the backend only allows production site origins).
 * In production builds, use the baked-in absolute API origin.
 * @param {string} path e.g. `/api/test-floorplan-full-analysis`
 */
export function resolveApiRequestUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (process.env.NODE_ENV === 'development') {
    return normalizedPath;
  }
  return HAS_API_URL ? `${API_BASE_URL}${normalizedPath}` : '';
}

/** Whether API calls can be attempted (proxy target or production API URL). */
export function canReachBackendApi() {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return HAS_API_URL;
}
